import React from 'react';
import { chip } from '../time/styles';

// Shared bits for task lists.

const STYLES = {
    PENDING: ['To do', '#3b82f6', 'rgba(59,130,246,0.12)'],
    SENT_BACK: ['Changes asked', '#d97706', 'rgba(217,119,6,0.12)'],
    SUBMITTED: ['With HR', '#8b5cf6', 'rgba(139,92,246,0.12)'],
    DONE: ['Done', '#10b981', 'rgba(16,185,129,0.12)'],
    SKIPPED: ['Not needed', '#6b7280', 'rgba(107,114,128,0.12)'],
};

export const TaskStatus = ({ status }) => {
    const [label, color, bg] = STYLES[status] || STYLES.PENDING;
    return <span data-status={status} style={{ ...chip, color, background: bg, borderColor: color, fontSize: 12, fontWeight: 600 }}>{label}</span>;
};

